module.exports = __webpack_public_path__ + "static/media/p_megapay.267b767a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pay/p_megapay.png
// module id = 2437
// module chunks = 7